import { UseQueryResult, useQuery, UseMutationResult, useMutation, QueryClient } from '@tanstack/react-query';
import { CreateOrderTransactionInput, CreateOrderTransactionResponse, ExportOrderTransaferInput, ExportOrderTransaferResponse, GetDataThaipostResponse, GetLoadNewOrderSkuInput, GetLoadNewOrderSkuResponse, GetOrderCancelResponse, GetOrderCompleteResponse, GetOrderProductSkuListInput, GetOrderProductSkuListResponse, GetOrderproductskuNewOrderInput, GetOrderproductskuNewOrderResponse, GetOrderWaitingRefundResponse, GetPendingSkuResponse, GetWaitingShipResponse, LotTransactionDetailInput, LotTransactionDetailResponse, MakeappointmentInput, MakeappointmentResponse, MakeOrderConfirmInput, NewOrderResponse, OlderLotTransactionInput, OlderLotTransactionResponse, OrderDistributedListResponse, OrderDistributedResponse, OrderTransactionInput, SubmitNewOrderInput, SubmitNewOrderResponse, UpdateApproveRequestCancelInput, UpdateApproveRequestCancelResponse, UpdateCapacityInput, UpdateCapacityResponse, UpdateDeleteRequestCancelInput, UpdateDeleteRequestCancelResponse, UpdateOrderTransactionInput, UpdateOrderTransactionResponse } from 'services/interface'

import { getNewOrder, getWaitingShip, postMakeappointment, getOrderComplete, getPendingsku, getOrderCancel, getOrderProductSkuList, postUpdateCapacity, submitNewOrderInput, getInprocess, getDataThaipost, getOrderWaitingRefund, updateApproveRequestCancel, updateDeleteRequestCancel, getOrderproductskuNewOrder, postMakeOrderConfirm, getLoadNewOrderSku, createOrderTransaction, getOrderDistributed, getLotTransactionDetail, getOlderLotTransaction, getExportOrderTransafer, getOrderDistributedList, rollbackOrderTransaction } from 'services/ordersApi'

export const useGetNewOrders = (): UseQueryResult<NewOrderResponse, Error> => {
  return useQuery<NewOrderResponse, Error>({
    queryKey: ['newOrders'],
    queryFn: getNewOrder,
    // staleTime: 1000 * 60 * 60 * 24,
  });
};

export const useGetOrdersInprocess = (): UseQueryResult<NewOrderResponse, Error> => {
  return useQuery<NewOrderResponse, Error>({
    queryKey: ['getOrderInprocess'],
    queryFn: getInprocess,
    staleTime: 1000 * 60 * 60 * 24, // cache for 24 hours
  });
};

export const useGetWaitingShip = (): UseQueryResult<GetWaitingShipResponse, Error> => {
  return useQuery<GetWaitingShipResponse, Error>({
    queryKey: ['waitingShip'],
    queryFn: getWaitingShip,
    staleTime: 1000 * 60 * 60 * 24, // cache for 24 hours
  });
};

export const useGetOrderComplete = (): UseQueryResult<GetOrderCompleteResponse, Error> => {
  return useQuery<GetOrderCompleteResponse, Error>({
    queryKey: ['orderComplete'],
    queryFn: getOrderComplete,
    staleTime: 1000 * 60 * 60 * 24, // cache for 24 hours
  });
};

export const useGetOrderWaitingRefund = (): UseQueryResult<GetOrderWaitingRefundResponse, Error> => {
  return useQuery<GetOrderWaitingRefundResponse, Error>({
    queryKey: ['orderWaitingRefund'],
    queryFn: getOrderWaitingRefund,
    staleTime: 1000 * 60 * 60 * 24, // cache for 24 hours
  });
};

export const useGetOrderCancel = (): UseQueryResult<GetOrderCancelResponse, Error> => {
  return useQuery<GetOrderCancelResponse, Error>({
    queryKey: ['orderCancel'],
    queryFn: getOrderCancel,
    staleTime: 1000 * 60 * 60 * 24, // cache for 24 hours
  });
};

export const useGetPendingsku = (): UseQueryResult<GetPendingSkuResponse, Error> => {
  return useQuery<GetPendingSkuResponse, Error>({
    queryKey: ['pendingsku'],
    queryFn: getPendingsku,
    staleTime: 1000 * 60 * 60 * 24, // cache for 24 hours
  });
};


export const useSubmitMakeappointment = (): UseMutationResult<
  MakeappointmentResponse,
  Error,
  MakeappointmentInput,
  unknown
> => {
  const queryClient = new QueryClient();
  return useMutation<MakeappointmentResponse, Error, MakeappointmentInput, unknown>({
    mutationFn: postMakeappointment,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['waitingShip'] });
    },
  });
};

// Update approve request cancel
export const useUpdateApproveRequestCancel = (): UseMutationResult<
  UpdateApproveRequestCancelResponse,
  Error,
  UpdateApproveRequestCancelInput,
  unknown
> => {
  return useMutation<UpdateApproveRequestCancelResponse, Error, UpdateApproveRequestCancelInput, unknown>({
    mutationFn: updateApproveRequestCancel,
  });
};

// Update delete request cancel
export const useUpdateDeleteRequestCancel = (): UseMutationResult<
  UpdateDeleteRequestCancelResponse,
  Error,
  UpdateDeleteRequestCancelInput,
  unknown
> => {
  return useMutation<UpdateDeleteRequestCancelResponse, Error, UpdateDeleteRequestCancelInput, unknown>({
    mutationFn: updateDeleteRequestCancel,
  });
};


export const useGetOrderProductSkuList = (
  input: GetOrderProductSkuListInput
): UseQueryResult<GetOrderProductSkuListResponse, Error> => {
  return useQuery<GetOrderProductSkuListResponse, Error>({
    queryKey: ['orderProductSkuList', input.start_date, input.end_date],
    queryFn: () => getOrderProductSkuList(input),
    staleTime: 1000 * 60 * 60 * 24,
  });
};

// Update capacity
export const useUpdateCapacity = (): UseMutationResult<
  UpdateCapacityResponse,
  Error,
  UpdateCapacityInput,
  unknown
> => {
  return useMutation<UpdateCapacityResponse, Error, UpdateCapacityInput, unknown>({
    mutationFn: postUpdateCapacity,
  });
};

export const useSubmitNewOrder = (): UseMutationResult<
  SubmitNewOrderResponse,
  Error,
  SubmitNewOrderInput,
  unknown
> => {
  return useMutation<SubmitNewOrderResponse, Error, SubmitNewOrderInput, unknown>({
    mutationFn: submitNewOrderInput,
  });
};


export const useGetDataThaipost = (): UseQueryResult<GetDataThaipostResponse, Error> => {
  return useQuery<GetDataThaipostResponse, Error>({
    queryKey: ['getDataThaipost'],
    queryFn: getDataThaipost,
    staleTime: 1000 * 60 * 60 * 24, // cache for 24 hours
  });
};

export const useGetOrderproductskuNewOrder = (
  input: GetOrderproductskuNewOrderInput
): UseQueryResult<GetOrderproductskuNewOrderResponse, Error> => {
  return useQuery<GetOrderproductskuNewOrderResponse, Error>({
    queryKey: ['getOrderproductskuNewOrder', input.limit, input.offset],
    queryFn: () => getOrderproductskuNewOrder(input),
    // staleTime: 1000 * 60 * 60 * 24,
  });
};

export const useSubmitMakeOrderConfirm = (): UseMutationResult<
  MakeappointmentResponse,
  Error,
  MakeOrderConfirmInput,
  unknown
> => {
  return useMutation<MakeappointmentResponse, Error, MakeOrderConfirmInput, unknown>({
    mutationFn: (input: MakeOrderConfirmInput) => postMakeOrderConfirm(input),
  })
}

export const useCreateOrderTransaction = (): UseMutationResult<
  CreateOrderTransactionResponse,
  Error,
  CreateOrderTransactionInput,
  unknown
> => {
  return useMutation<CreateOrderTransactionResponse, Error, CreateOrderTransactionInput, unknown>({
    mutationFn: (input: CreateOrderTransactionInput) => createOrderTransaction(input),
  })
}

export const useUpdateOrderTransaction = (): UseMutationResult<
  UpdateOrderTransactionResponse,
  Error,
  UpdateOrderTransactionInput,
  unknown
> => {
  return useMutation<UpdateOrderTransactionResponse, Error, UpdateOrderTransactionInput, unknown>({
    mutationFn: (input: UpdateOrderTransactionInput) => rollbackOrderTransaction(input),
  })
}

export const useGetLoadNewOrderSku = (
  input: GetLoadNewOrderSkuInput
): UseQueryResult<GetLoadNewOrderSkuResponse, Error> => {
  return useQuery<GetLoadNewOrderSkuResponse, Error>({
    queryKey: ['getLoadNewOrderSku', input.limit, input.offset],
    queryFn: () => getLoadNewOrderSku(input),
    staleTime: 1000 * 60 * 60 * 24,
    refetchOnWindowFocus: false,
  })
}

export const useGetOrderDistributed = (input: string): UseQueryResult<OrderDistributedResponse, Error> => {
  return useQuery<OrderDistributedResponse, Error>({
    queryKey: ['getOrderDistributed', input],
    queryFn: () => getOrderDistributed(input),
  })
}

export const useGetOrderDistributedList = (
  input: OrderTransactionInput
): UseQueryResult<OrderDistributedListResponse, Error> => {
  return useQuery<OrderDistributedListResponse, Error>({
    queryKey: ['getOrderDistributedList', input.limit, input.offset, input.search, input.tran_date],
    queryFn: () => getOrderDistributedList(input),
  })
}



export const useGetLotTransactionDetail = (
  input: LotTransactionDetailInput
): UseQueryResult<LotTransactionDetailResponse, Error> => {
  return useQuery<LotTransactionDetailResponse, Error>({
    queryKey: ['orderLotTransactionDetail', input.dc_id, input.province_id, input.lot_no, input.date_start, input.date_end, input.limit, input.offset, input.search, input.status_list],
    queryFn: () => getLotTransactionDetail(input),
  })
}

export const useGetOlderLotTransaction = (
  input: OlderLotTransactionInput
): UseQueryResult<OlderLotTransactionResponse, Error> => {
  return useQuery<OlderLotTransactionResponse, Error>({
    queryKey: ['orderLotTransaction', input.date_start, input.date_end, input.limit, input.offset, input.search, input.status_list],
    queryFn: () => getOlderLotTransaction(input),
  })
}

export const useGetExportOrderTransafer = (
  input: ExportOrderTransaferInput
): UseQueryResult<ExportOrderTransaferResponse, Error> => {
  return useQuery<ExportOrderTransaferResponse, Error>({
    queryKey: ['ExportOrderTransfer', input.search, input.limit, input.offset],
    queryFn: () => getExportOrderTransafer(input),
    staleTime: 1000 * 60 * 60 * 24,
  })
}

export const useGetCompleteOrder = (
  input: GetOrderproductskuNewOrderInput
): UseQueryResult<GetOrderproductskuNewOrderResponse, Error> => {
  return useQuery<GetOrderproductskuNewOrderResponse, Error>({
    queryKey: ['getCompleteOrder', input],
    queryFn: () => getOrderproductskuNewOrder(input),
  })
}

export const useGetCancelOrder = (
  input: GetOrderproductskuNewOrderInput
): UseQueryResult<GetOrderproductskuNewOrderResponse, Error> => {
  return useQuery<GetOrderproductskuNewOrderResponse, Error>({
    queryKey: ['getCancelOrder', input.sort_by, input.limit, input.offset, input.search],
    queryFn: () => getOrderproductskuNewOrder(input),
  })
}